import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { StoryblokComponent, useStoryblokState } from 'gatsby-source-storyblok';

const BusinessFooterWrapper = () => {
  const data = useStaticQuery(graphql`
    query BusinessFooterStoryQuery {
      storyblokEntry(full_slug: { eq: "business/footer" }) {
        content
        full_slug
        internalId
        name
        uuid
      }
    }
  `);
  const story = useStoryblokState(data.storyblokEntry);

  return story?.content && <StoryblokComponent blok={story.content} />;
};

export default BusinessFooterWrapper;
